import { render, staticRenderFns } from "./OverviewSection.vue?vue&type=template&id=0c53bf78&scoped=true"
import script from "./OverviewSection.vue?vue&type=script&lang=js"
export * from "./OverviewSection.vue?vue&type=script&lang=js"
import style0 from "./OverviewSection.vue?vue&type=style&index=0&id=0c53bf78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c53bf78",
  null
  
)

export default component.exports